var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown site-language" }, [
    _c(
      "button",
      {
        staticClass: "dropbtn",
        on: {
          click: function($event) {
            _vm.currentLanguage.onClick()
          }
        }
      },
      [
        _c("img", {
          staticClass: "flag-icon",
          attrs: { src: _vm.currentLanguage.flag, width: "20", height: "15" }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "site-option" }, [
          _vm._v(_vm._s(_vm.currentLanguage.label))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dropdown-content" }, [
      _c(
        "button",
        {
          staticClass: "dropbtn",
          on: {
            click: function($event) {
              _vm.languageOption.onClick()
            }
          }
        },
        [
          _c("img", {
            staticClass: "flag-icon",
            attrs: { src: _vm.languageOption.flag, width: "20", height: "15" }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "site-option" }, [
            _vm._v(_vm._s(_vm.languageOption.label))
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cde44b64", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cde44b64","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/site-language/SiteLanguage.vue
// module id = 142
// module chunks = 0